import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../reducers";
// import { SalesInvoiceService } from "../../../services/salesinvoice.service";
import { Combo2Service, WorkOrderService } from "../../services/index";
import { SalesInvoiceService } from "../../services/salesinvoice.service";
import { PartyService, SalesOrderService, PurchaseOrderService } from "../../services/index";


@Component({
  selector: "addEditInvoice",
  templateUrl: "./productionMaster.html",
})
export class productionMaster {
  @ViewChild("tbody1") tbody1;
  row: any;
  data: any;
 
  execApi: boolean = true;
  show_det: boolean = true;

  invoicedata: any = {

   types: "",
   part:"",

  };
  typesList = ["FRONT","COLLAR"];
  partList = [""];
  mode: string;
  saveEvent: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  listSelected = [];
  isLoadMask: Promise<any>;
  @Input() _params: any;
  seasonList: any;
  dataList = [];

  @Input() set params(val: any[]) {
    if (_.isEmpty(val)) {
      let row: any = {};
      row.tabevent = new EventEmitter();
      let tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD AGENT DEDUCTION",
          title: "ADD AGENT DEDUCTION",
          tabParent: "SALES_ORDER",
          mode: "Add",
          data: row,
          name: "ADD AGENT DEDUCTION",
        },
      };
      this._params = tabObj;
      val = this._params;
      this.mode = tabObj.params.mode;
      this.saveEvent = row.tabevent;
      let invoicedata = Object.assign({}, tabObj.params["data"]);
      // this.acdata = designdata;
    } else {
      this._params = val;
      this.mode = val["mode"];
      this.saveEvent = val["data"].tabevent;
      let invoicedata = Object.assign({}, val["data"]);
      this.invoicedata = invoicedata;
      this.invoicedata.disper = invoicedata.disper;
    }
    if (this.mode == "Convert") {
      this.invoicedata.mode = "Add";
    }

    if (this.mode == "Convert") {
      //  this.editInvoiceList();
      this.invoicedata.ref_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      //   this.oncheck(this.invoicedata.salesorder);
    }
    if (this.mode == "View" || this.mode == "Edit") {
  

      //    this.invoicedata.ref_date = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  OrderNoCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private salesinvservice: WorkOrderService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService,
    private partyService: PartyService
  ) {
    this.row = {

      types: "",
      part:""

    };
    this.data = {
      invoiceList: [],
    };
  }
  ngOnInit() {
    this.getProductionMaster();
    this.tableScroll();
    this.invoicedata.mode = this.mode;
  }

  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }

  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      // let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      // a.removeClass('mat-autocomplete-visible');
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 500);
    }
  }


    addEditPO(mode: string, row: any): void {
        let listUpdateEvent = new EventEmitter();
        row['stylelist'] = this.data.invoiceList;
        listUpdateEvent.subscribe(() => {
          this.getProductionMaster();
        });
        row.tabevent = listUpdateEvent;
        let tabObj = {};
        if (mode == "Add") {
            tabObj = {
                action: "NewTab",
                params: {
                    //  tabParent: 'Transaction',
                    tabName: "ADD PRODUCTIONLISTMASTER",
                    title: "ADD PRODUCTIONLISTMASTER",
                    tabParent: "MASTER",
                    mode: mode,
                    data: row,
                    name: "ADD PRODUCTIONLISTMASTER"
                },
            };
        }
        this.tabUpdateEvent.emit(tabObj);
    }


  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind;
    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "bar" && nxtRow.length == 0) {
      let rowdetail = Object.assign({}, this.row);
      nxtInd = nxtInd + 1;
      $("#" + "bar" + "-" + nxtInd).focus();
    } else {
      setTimeout(() => {
        let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
        a.removeClass("mat-autocomplete-visible");
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }

  isRowEmpty(ind) {
    let data = this.data.invoiceList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  
  onbackdet(){
    this.show_det = true;
    console.log(this.data.invoiceList);
    this.getProductionMaster();
  }

    getProductionMaster() { 

        let params = {
          
          types:this .invoicedata.types,
          part:this .invoicedata.part
     
    
        };
        console.log(this.invoicedata);
        this.salesinvservice.getProductionMasterDetails(params).then((res: any) => {
          this.dataList = res.data;
          this.data.invoiceList = res.data;
          console.log(this.data.invoiceList);
          var bottom = document.querySelector("#salesTbody");
          setTimeout(() => {
            bottom.scrollTop = bottom.scrollHeight;
          }, 500);
    
        });
      }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getEditMode(ind){
this.mode = 'Edit';
console.log(this.data.invoiceList);

  }

  getTbodyStyle() {
    let height = 300;
    if (this.tbody1) {
      height -= this.tbody1.nativeElement.offsetHeight;
    }
    const width = {
      display: "block",
      width: "1px",
      height: height + "px",
      "overflow-y": "scroll",
    };
    return width;
  }
  oncheckemptyrow(){
   
      let params: any = Object.assign({}, this.invoicedata);
      params["tabevent"] = undefined;
      params["data"] = JSON.stringify(this.data.invoiceList);
      let that = this;

      swal({
        title: "Are you sure to save this Changes?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoadMask = that.salesinvservice
          .saveProductionMasterDetails(params)
          .then(function (res: any) {
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              if (that.mode == "Add") {
                this. getProductionMaster();
           
              } else {
                this. getProductionMaster();
 
              }
            }
            else {
              swal("This Design" +" " + res.message);
            }
          })
          .catch(function (error: any) {
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
   
  }
  
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/productionMaster.ts